/**
 * Bilt brand geometry — combination wrench (mark) + compact diagonal open-end (score pips).
 */

export const BILT_BRAND_VIEWBOX = '0 0 64 64';

/**
 * Combination wrench, upright (jaws top, box bottom).
 * evenodd punches the box-end eye.
 */
export const BILT_WRENCH_PATH = [
  'M19 19',
  'L19 10',
  'L23.2 5',
  'L26.8 5',
  'L26.8 14.5',
  'L37.2 14.5',
  'L37.2 5',
  'L40.8 5',
  'L45 10',
  'L45 19',
  'L49.5 24.5',
  'L43.5 30',
  'L36 30',
  'L36 38',
  'C43.5 39.2 49 44.2 49 50.5',
  'C49 56.8 41.5 61.5 32 61.5',
  'C22.5 61.5 15 56.8 15 50.5',
  'C15 44.2 20.5 39.2 28 38',
  'L28 30',
  'L20.5 30',
  'L14.5 24.5',
  'Z',
  'M32 45.5',
  'C35.1 45.5 37.5 47.9 37.5 51',
  'C37.5 54.1 35.1 56.5 32 56.5',
  'C28.9 56.5 26.5 54.1 26.5 51',
  'C26.5 47.9 28.9 45.5 32 45.5',
  'Z',
].join(' ');

/** Bench angle for full combination mark. */
export const BILT_WRENCH_TRANSFORM = 'rotate(-30 32 34)';

/**
 * Compact open-end wrench for build-score pips (reads at 14–16px).
 * Constructed upright then rotated to match logo italic lean (~-32°).
 */
export const BILT_SCORE_VIEWBOX = '0 0 24 24';

/** Upright open-end wrench — clean geometric jaws + tapered handle (reads at 14–16px). */
export const BILT_SCORE_WRENCH_PATH = [
  // Outer silhouette (clockwise from left jaw tip)
  'M6.5 4.2',
  'C6.5 3.5 7.05 3 7.75 3',
  'L9.6 3',
  'C10.15 3 10.55 3.45 10.55 4',
  'L10.55 7.35',
  'L13.45 7.35',
  'L13.45 4',
  'C13.45 3.45 13.85 3 14.4 3',
  'L16.25 3',
  'C16.95 3 17.5 3.5 17.5 4.2',
  'L17.5 8.1',
  'C17.5 8.55 17.3 8.95 16.95 9.2',
  'L14.85 10.7',
  'L14.85 18.6',
  'C14.85 20.55 13.55 21.85 12 21.85',
  'C10.45 21.85 9.15 20.55 9.15 18.6',
  'L9.15 10.7',
  'L7.05 9.2',
  'C6.7 8.95 6.5 8.55 6.5 8.1',
  'Z',
  // Jaw opening (evenodd cutout)
  'M10.55 4.85',
  'L13.45 4.85',
  'L13.45 6.55',
  'L10.55 6.55',
  'Z',
].join(' ');

/** Logo-matched lean for score pips. */
export const BILT_SCORE_WRENCH_TRANSFORM = 'rotate(-32 12 12)';
export const BILT_SCORE_WRENCH_FILL_RULE = 'evenodd' as const;

export const BILT_BRAND_TILE_CLASS = 'bg-gradient-brand-tile';

export const BILT_BRAND_GRADIENT = {
  from: '#f97316',
  mid: '#c2410c',
  to: '#2e1065',
};
